import { useRef, useState } from 'react';

import { useCloseMenuIfClickedOutside } from 'coreOld/hooks';
import { isEmptyObject } from 'coreOld/utils';

import AdvancedFilterView from './AdvancedFilterView';

interface IProps {
  values?: Record<string, any>;
  customPanelStyle?;
  advancedFiltersConfig?;
  advancedFiltersValues?: Record<string, any>;
  onChangeAdvancedFilter: (name: string, value: number | string, clearFilters?: boolean) => void;
  onApplyAdvancedFilters: () => void;
}

const getAppliedAdvancedFilters = (advancedFiltersValues) =>
  Object.values(advancedFiltersValues).filter(Boolean).length;

const AdvancedFilter = ({
  values,
  customPanelStyle,
  advancedFiltersConfig,
  advancedFiltersValues,
  onChangeAdvancedFilter,
  onApplyAdvancedFilters,
}: IProps) => {
  const ref = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [appliedAdvancedFilters, setAppliedAdvancedFilters] = useState<number>(
    getAppliedAdvancedFilters(advancedFiltersValues) || 0
  );

  useCloseMenuIfClickedOutside(ref, isModalOpen, () => setIsModalOpen(false));

  const handleChangeAdvancedFilter = (
    name: string,
    value: number | string,
    clearFilters?: boolean
  ) => {
    if (isEmptyObject(advancedFiltersValues)) {
      onClear(undefined, undefined, true);
    }

    onChangeAdvancedFilter(name, value, clearFilters);
  };

  const onClear = (name: string, value: number | string, clearFilters?: boolean) => {
    onChangeAdvancedFilter(name, value, clearFilters);
    setAppliedAdvancedFilters(0);
  };

  return (
    <AdvancedFilterView
      values={values}
      customPanelStyle={customPanelStyle}
      advancedFiltersConfig={advancedFiltersConfig}
      advancedFiltersValues={advancedFiltersValues}
      onChangeAdvancedFilter={handleChangeAdvancedFilter}
      onApplyAdvancedFilters={onApplyAdvancedFilters}
      onClearAdvancedFilters={onClear}
      appliedAdvancedFilters={appliedAdvancedFilters}
      setAppliedAdvancedFilters={setAppliedAdvancedFilters}
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      ref={ref}
    />
  );
};

export default AdvancedFilter;
